import React from 'react';
import { useClient } from '../../context/ClientContext';

const DATE_RANGES = [
  { value: 'mtd', label: 'Month to Date' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '14d', label: 'Last 14 Days' },
  { value: '30d', label: 'Last 30 Days' }
];

export default function Header({ onRefresh, refreshing, dateRange, onDateRangeChange }) {
  const { brand } = useClient();

  return (
    <header className="sticky top-0 z-10 bg-white border-b border-gray-200 no-print">
      <div className="px-6 py-4 flex items-center justify-between">
        <div>
          <h1
            className="text-lg font-semibold text-gray-900"
            style={{ fontFamily: brand.typography?.headerFont }}
          >
            {brand.brandName}
          </h1>
          <p className="text-xs text-gray-500">Google Ads Dashboard</p>
        </div>

        <div className="flex items-center gap-3">
          <select
            value={dateRange}
            onChange={(e) => onDateRangeChange(e.target.value)}
            className="text-sm border border-gray-200 rounded-lg px-3 py-1.5 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-1 cursor-pointer"
            style={{ focusRingColor: brand.colors?.primary || '#2563eb' }}
          >
            {DATE_RANGES.map(r => (
              <option key={r.value} value={r.value}>{r.label}</option>
            ))}
          </select>

          <button
            onClick={() => window.print()}
            className="hidden md:flex p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600"
            title="Print / Save as PDF"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
          </button>

          <button
            onClick={onRefresh}
            disabled={refreshing}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600 disabled:opacity-50"
            title="Refresh data"
          >
            <svg
              className={`w-5 h-5 ${refreshing ? 'animate-spin' : ''}`}
              fill="none" viewBox="0 0 24 24" stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
